import { render } from "./AnnouncementsModal.vue?vue&type=template&id=5b72528b&scoped=true"
import script from "./AnnouncementsModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementsModal.vue?vue&type=script&lang=js"

import "./AnnouncementsModal.vue?vue&type=style&index=0&id=5b72528b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b72528b"]])

export default __exports__